import * as React from "react";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";                            
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Controller } from "react-hook-form";

export const DateTimeField = ({
  name,
  control,
  label,
  required = false,
  setNowOnChange = false,
}: any) => {
  const hasSetNowRef = React.useRef(false);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="en-gb"
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <DateTimePicker
            label={label}
            value={value ? dayjs(value) : null}
            format="DD/MM/YYYY HH:mm"
            ampm={false}
            onChange={newValue => onChange(newValue)}
            onOpen={() => {
              if (setNowOnChange && !value && !hasSetNowRef.current) {
                hasSetNowRef.current = true;
                onChange(dayjs());
              }
            }}
            slotProps={{
              textField: {
                required,
                fullWidth: true,
                error: !!error,
                helperText: error?.message,
              } as any,
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};